(function () {
  'use strict';

  angular
    .module('app.category', [])

    /* @ngInject */
    .factory('InfiniteScrollApi', ["$location", "CategoryService", "CategoryCacheService", "RoutesService", function ($location, CategoryService, CategoryCacheService, RoutesService) {
      var api = function (ctrl) {
        this.ctrl = ctrl;
        this.items = [];
        this.busy = false;
        this.page = ctrl.currentPage;
        this.facets = [];
        this.search = '';
      };

      api.prototype.nextPage = function () {
        if ($location.path().indexOf('-c-') === -1) return;

        if (!preProcess(this)) return;

        postProcess(this);
      };

      api.prototype.nextSearchPage = function () {
        if (!preProcess(this) || (this.ctrl.api.page === 1 && !this.ctrl.infiniteScroll)) return;

        this.search = $location.search().q || '';
        if (!this.search) {
          var routeUrl = '/' + RoutesService.getUrlByName('Search') + '/';
          var search = $location.path().split(routeUrl)[1];
          if (search) {
            this.search = search.indexOf('/') === -1 ? search : search.split('/')[0];
          }
        }
        this.search = decodeURI(this.search.replace('+', ' '));

        postProcess(this);
      };

      function preProcess(_this) {
        if (_this.maxPage === 0) return false;
        if (_this.busy || _this.page === _this.maxPage) return false;
        if (_this.filtered && !_this.filteredActive) return false;
        if (_this.page % _this.ctrl.iScrollMaxPages === 0) return false;

        return true;
      }

      function postProcess(_this) {
        _this.busy = true;
        CategoryService.getProducts(++_this.page, _this.filtered, _this.sort, _this.facets, _this.brands, _this.reviews, _this.types, _this.prices, _this.search, _this.idCategory, _this.nbPerPage)
          .then(function (data) {
            if (data) {
              _this.items = _this.items.concat(data.products);
              CategoryCacheService.set($location.url(), _this.page, _this.items, data.total);
              _this.busy = false;
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      }

      return api;
    }])

    /* @ngInject */
    .directive('categoryProducts', function () {
      return {
        restrict: 'A',
        scope: true,
        bindToController: {
          idCategory: '<',
          searchQuery: '@?',
          currentPage: '<',
          totalProducts: '<',
          nbPerPage: '<',
          maxPage: '<',
          sort: '@',
          sortTitle: '@',
          iScrollMaxPages: '<',
          device: '<'
        },
        controllerAs: 'categoryCtrl',
        /* @ngInject */
        controller: ["$scope", "$element", "$rootScope", "$document", "$timeout", "$location", "$filter", "InfiniteScrollApi", "productsGridService", "CategoryCacheService", "CategoryService", "RoutingService", "RoutesService", function ($scope, $element, $rootScope, $document, $timeout, $location, $filter, InfiniteScrollApi, productsGridService, CategoryCacheService, CategoryService, RoutingService, RoutesService) {
          var ctrl = this,
            loadCache;

          CategoryService.setGridCtrl(ctrl);

          // Init filters as it is async
          $filter('discount')(1, 'value');
          $filter('price')(1, 'value');

          ctrl.$onInit = function () {
            if (window.isBot || window.isCache) {
              ctrl.nbProducts = ctrl.totalProducts;
              return;
            }

            ctrl.api = new InfiniteScrollApi(ctrl);

            var locSearch = {};
            _.each($location.search(), function (value, key) {
              if (key.indexOf('f') === 0) {
                locSearch[key] = value;
              }
            });
            ctrl.api.filtered = !_.isEmpty(locSearch);

            ctrl.api.idCategory = ctrl.idCategory;
            ctrl.api.searchQuery = angular.isDefined(ctrl.searchQuery) ? ctrl.searchQuery : null;
            ctrl.api.nbPerPage = ctrl.nbPerPage;
            ctrl.api.maxPage = ctrl.maxPage;
            ctrl.api.sort = ctrl.sort || '';

            var cache = CategoryCacheService.get($location.url());
            if (cache) {
              loadCache = true;
              $timeout(function () {
                $rootScope.$broadcast('showPageLoader', true);
              });

              ctrl.api.page = cache[0];
              ctrl.api.items = cache[1];
              ctrl.nbProducts = cache[2];
            }

            if (!ctrl.api.filtered) {
              ctrl.nbProducts = ctrl.totalProducts;
              ctrl.paginationEnabled = true;
            }

            ctrl.iScrollPage = Math.floor(ctrl.currentPage / ctrl.iScrollMaxPages) + 1;
            ctrl.iScrollNbPerPage = ctrl.api.nbPerPage * ctrl.iScrollMaxPages;
          };
          ctrl.$onDestroy = function () {
            ctrl.api.busy = true;
          };

          ctrl.loaded = function (reload) {
            reload = reload || false;
            $timeout(function () {
              productsGridService.resizeGrid('productsGrid', ctrl.device.size, reload);
              $rootScope.$emit('lazyImg:refresh');
              if (loadCache) {
                loadCache = false;
                setTimeout(RoutingService.windowScroll, 100);
                $timeout(function () {
                  $rootScope.$broadcast('showPageLoader', false);
                });
              }
            });
          };

          ctrl.openDropdown = function (event) {
            var $button = $(event.currentTarget),
              $menu = $button.siblings('.dropdown-menu');
            if ($button.parent().hasClass('open')) {
              $menu.removeAttr('style');
            } else if (ctrl.device.xxs) {
              $menu.css({
                left: $button.offset().left * -1 + 10,
                width: $(document.body).width() - 20
              });

              var closeDropdown = function () {
                $menu.removeAttr('style');
                $document.off('click', closeDropdown);
              };

              $timeout(function () {
                $document.on('click', closeDropdown);
              }, 500);
            }
          };

          ctrl.setSort = function (event, value) {
            event.preventDefault();
            ctrl.sort = value;
            ctrl.sortTitle = event.target.innerText;
            $location.path($(event.target).attr('href'));
          };

          ctrl.gotoPage = function () {
            var page = ((ctrl.iScrollPage - 1) * ctrl.iScrollMaxPages) + 1,
              routing = RoutingService.get(),
              routeUrl = '/' + RoutesService.getUrlByName('SortedCategoryPage'),
              url = routeUrl
                .replace('{categoryName}', routing.to.params.categoryName)
                .replace('{categoryId:int}', routing.to.params.categoryId.split('-')[0])
                .replace('-{page:int}', page === 1 ? '' : '-' + page)
                .replace('/{sortType:alpha}', ctrl.api.sort === '' ? '' : '/' + ctrl.api.sort);

            RoutingService.scrollCache[RoutingService.getPath(url)] = 0;
            $location.path(url);
          };

          ctrl.gotoSearchPage = function () {
            var page = ((ctrl.iScrollPage - 1) * ctrl.iScrollMaxPages) + 1,
              routing = RoutingService.get(),
              routeUrl = '/' + RoutesService.getUrlByName(routing.to.name.indexOf('SearchProducts') !== -1 ? 'SortedSearchProductsPageAngular' : 'SortedSearchPageAngular'),
              url = routeUrl
                .replace('{q}', routing.to.params.q ? routing.to.params.q : '')
                .replace('/{p:int}', page === 1 ? '' : '/' + page)
                .replace('/{sort:alpha}', ctrl.api.sort === '' ? '' : '/' + ctrl.api.sort);

            RoutingService.scrollCache[RoutingService.getPath(url)] = 0;
            $location.path(url);
          };

          ctrl.activateInfiniteScroll = function () {
            ctrl.infiniteScroll = true;
            ctrl.api.nextSearchPage();
          };

          ctrl.showPagination = function () {
            if (ctrl.api.busy) return false;
            if (ctrl.api.maxPage === 1) return false;
            if (ctrl.api.maxPage <= ctrl.iScrollMaxPages) return false;
            if (ctrl.api.page % ctrl.iScrollMaxPages !== 0 && ctrl.api.page !== ctrl.api.maxPage) return false;

            return true;
          };

        }]
      };
    });

})();
